import {
  BarChart3,
  BookOpen,
  Bot,
  Brain,
  Briefcase,
  Database,
  FileText,
  Workflow,
  Headphones,
  Library,
  type LucideIcon,
  Mail,
  Search,
  Shield,
  ShoppingCart,
  Sparkles,
  Table,
  Truck,
  Wrench,
} from 'lucide-react';

// An agent's icon: an emoji drawn as text, or the name of a glyph (kebab case). The old page looked
// every lucide name up (the whole icon set in the bundle); here a curated set, anything else a Bot.
const GLYPHS: Record<string, LucideIcon> = {
  bot: Bot,
  'bar-chart': BarChart3,
  chart: BarChart3,
  book: BookOpen,
  'book-open': BookOpen,
  brain: Brain,
  briefcase: Briefcase,
  database: Database,
  'file-text': FileText,
  workflow: Workflow,
  headphones: Headphones,
  library: Library,
  mail: Mail,
  search: Search,
  shield: Shield,
  'shopping-cart': ShoppingCart,
  sparkles: Sparkles,
  table: Table,
  truck: Truck,
  wrench: Wrench,
};

/** An emoji: at most three code points, at least one pictographic. */
export const isEmoji = (s: string | null | undefined): boolean =>
  !!s && [...s].length <= 3 && /\p{Extended_Pictographic}/u.test(s);

export function AgentIcon({
  icon,
  size = 18,
  className = '',
}: {
  icon: string | null;
  size?: number;
  className?: string;
}) {
  if (isEmoji(icon))
    return (
      <span
        aria-hidden
        data-testid="agent-icon"
        className={`inline-flex items-center justify-center leading-none ${className}`}
        style={{ fontSize: size, width: size + 4, height: size + 4 }}
      >
        {icon}
      </span>
    );
  const Glyph = (icon && GLYPHS[icon.trim().toLowerCase()]) || Bot;
  return <Glyph data-testid="agent-icon" size={size} className={`text-nav-active ${className}`} />;
}

export const GLYPH_NAMES = Object.keys(GLYPHS);
